import React from 'react';
import { motion } from 'framer-motion';
import { LinkedinIcon, MailIcon, MapPinIcon } from 'lucide-react';
import { SugaarLogo } from './SugaarLogo';
export function Footer() {
  return <footer className="py-12 px-6 border-t border-forest-light/20" data-id="element-74">
      <div className="max-w-4xl mx-auto" data-id="element-75">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="flex flex-col md:flex-row items-center justify-between gap-6" data-id="element-76">
          {/* Contact Links */}
          <div className="flex flex-wrap items-center justify-center gap-6" data-id="element-77">
            <a href="https://linkedin.com/in/mikelarriba" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 text-parchment hover:text-flame transition-colors duration-200" data-id="element-78">
              <LinkedinIcon className="w-5 h-5" data-id="element-79" />
              <span className="text-sm" data-id="element-80">LinkedIn</span>
            </a>

            <a href="mailto:mikel.arriba@gmail.com" className="flex items-center gap-2 text-parchment hover:text-flame transition-colors duration-200" data-id="element-81">
              <MailIcon className="w-5 h-5" data-id="element-82" />
              <span className="text-sm" data-id="element-83">mikel.arriba@gmail.com</span>
            </a>

            <span className="flex items-center gap-2 text-parchment/60" data-id="element-84">
              <MapPinIcon className="w-5 h-5" data-id="element-85" />
              <span className="text-sm" data-id="element-86">Vitoria-Gasteiz, Spain</span>
            </span>
          </div>

          {/* Tagline with Logo */}
          <div className="flex items-center gap-2 text-parchment/80 text-sm" data-id="element-87">
            <img src="https://cdn.magicpatterns.com/uploads/1TBctBDvAmiiZJAM3NEhCH/dragon-icon---fire.svg" alt="Sugaar logo" className="w-5 h-7 object-contain" data-id="element-88" />
            <span data-id="element-89">Sugaar · Built with vibes</span>
          </div>
        </motion.div>
      </div>
    </footer>;
}